// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609240704/js/" + chunkId + "." + {"44":"41c50f7a","225":"79df0e01","481":"298856e5","486":"b391c7ff","770":"ebf11c48"}[chunkId] + ".0.28791651858844347.chunk.js";
};